import { render, staticRenderFns } from "./theBarChart.vue?vue&type=template&id=d85572b8&scoped=true"
import script from "./theBarChart.vue?vue&type=script&lang=js"
export * from "./theBarChart.vue?vue&type=script&lang=js"
import style0 from "./theBarChart.vue?vue&type=style&index=0&id=d85572b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85572b8",
  null
  
)

export default component.exports